<div id="mobile-messagerie-container" class="bg-light border rounded">
	<div class="row my-4">
		<div class="col-12" *ngIf="!convOpen">
			<app-list-user-messaging
				*ngIf="!newConv"
				(openConversation)="detectOpenConv($event)"
				(newConvEvent)="receiveNewConvAction($event)"
				(receiverEmitter)="changeConversation($event)"
				[notifications]="notifications"
				[conversation]="conversations"
				[currentUser]="currentUser"
			>
			</app-list-user-messaging>

			<app-new-conversation
				*ngIf="newConv"
				(openConversation)="detectOpenConv($event)"
				(newConvClose)="receiveNewConvClose($event)"
				(receiver)="changeConversation($event)"
				[secondPersonId]="userReceiver"
				[usersForNewConversation]="usersForNewConversation"
			>
			</app-new-conversation>
		</div>

		<!--WHEN ON DESKTOP-->
		<div class="col-12" *ngIf="userReceiver && convOpen">
			<div>
				<div>
					<div>
						<div class="row align-items-stretch border-bottom pb-2">
							<div
								(click)="backToConvList()"
								class="theme-blue-color col-1 back justify-content-center text-center hand-cursor"
							>
								<i class="fs-3 bi bi-arrow-left" aria-hidden="true"></i>
							</div>
							<span class="theme-main-color fs-4 col-11 fw-bold text-center">
								{{
									userReceiver?.employee?.firstName +
										' ' +
										userReceiver?.employee?.lastName
								}}
							</span>
						</div>
						<div class="row">
							<div #scrolleur class="vh-75 overflow-y-auto">
								<app-user-conversation
									[userReceiver]="userReceiver"
									[currentUser]="currentUser"
									[messages]="messages"
									(scrollToBottomEvent)="scrollToBottom()"
								></app-user-conversation>
							</div>
						</div>
						<div class="row ps-3 pe-3">
							<div
								class="input-group mb-3 d-flex align-items-end"
								[ngStyle]="!userReceiver ? { visibility: 'hidden' } : {}"
							>
								<input
									#messageContent
									type="text"
									class="form-control shadow"
									placeholder="Entrez votre message"
									[disabled]="isSendButtonDisabled"
									(keydown.enter)="
										sendMessage(userReceiver.id, messageContent.value)
									"
								/>
								<button
									class="shadow btn theme-main-color-button"
									[disabled]="isSendButtonDisabled"
									(click)="sendMessage(userReceiver.id, messageContent.value)"
								>
									Envoyer
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
